export function getRouterData(app) {
  return {};
}